import { render, staticRenderFns } from "./InteractiveImage_Labels.vue?vue&type=template&id=136940e4&"
import script from "./InteractiveImage_Labels.vue?vue&type=script&lang=js&"
export * from "./InteractiveImage_Labels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports